import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  styled,
  Stack,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import StyledButton from "../../Components/StyledButton";
import { useNavigate } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import axios from "axios";
import { set } from "react-hook-form";

const TextField = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    border: "1px solid",
    borderColor: "#E0E3E7",
    fontSize: 16,
    padding: "10px 12px",
  },
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: "20px",
    padding: theme.spacing(2),
  },
}));

const CreateAppUser = ({ reload }) => {
  const navigate = useNavigate();

  const [cardTypes, setCardTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // ✅ Individual states (NO formData)
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [plan, setPlan] = useState("");
  const [company, setCompany] = useState("");
  const [pincode, setPincode] = useState("");
  const [website, setWebsite] = useState("");
  const [cardType, setCardType] = useState(null); // full object
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    fetchCardTypes();
  }, []);

  const fetchCardTypes = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        navigate("/sign-in");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/v1/api/admin/getCardTypes`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response.status === 200) {
        setCardTypes(response.data.cards);
      }
    } catch (error) {
      console.error("Error fetching card types:", error);
    }
  };

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    // Reset form on close
    setFullName("");
    setEmail("");
    setPhoneNumber("");
    setAddress("");
    setDob("");
    setGender("");
    setPlan("");
    setCompany("");
    setPincode("");
    setWebsite("");
    setEmailError("");
    setCardType(null);
    setOpen(false);
  };

  const handleCreate = async () => {
    setLoading(false);
    const data = {
      fullName,
      email,
      phonenumber: phoneNumber,
      address,
      company,
      pincode,
      website,
    };

    // console.log("Form Data:", data);

    try {
      setLoading(true);
      const authToken = localStorage.getItem("authToken");
      if (!authToken) navigate("/sign-in");
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/api/appUser/create-appuser`,
        { ...data },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      reload();
      handleClose();
    } catch (error) {
      console.error(error);

      if (error.response?.status === 422) {
        const message = error.response?.data?.message;

        if (message === "EMAIL_ALREADY_EXIST") {
          setEmailError("Email already exists");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <StyledButton text={"Create User"} onClick={handleClickOpen} />

      <StyledDialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Create App User</DialogTitle>

        <DialogContent>
          <Stack spacing={2}>
            {/* Row 1 */}
            <Stack direction="row" gap={2}>
              <div style={{ width: "100%" }}>
                <TextField
                  fullWidth
                  placeholder="Enter Fullname"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
                {emailError && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  ></div>
                )}
              </div>

              <div style={{ width: "100%" }}>
                <TextField
                  fullWidth
                  placeholder="Enter Email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError(""); // clear error when typing
                  }}
                  onFocus={() => setEmailError("")}
                  style={{
                    border: emailError ? "1px solid red" : "",
                  }}
                />

                {emailError && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {emailError}
                  </div>
                )}
              </div>
            </Stack>

            {/* Row 2 */}
            <Stack direction="row" gap={2}>
              <TextField
                fullWidth
                placeholder="Enter Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />

              <TextField
                fullWidth
                placeholder="Enter Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Stack>

            {/* Row 3 */}
            <Stack direction="row" gap={2}>
              <TextField
                fullWidth
                placeholder="Pincode"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
              />

              <TextField
                fullWidth
                placeholder="Company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
            </Stack>
            <Stack direction="row" gap={2}>
              <TextField
                fullWidth
                placeholder="Website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
              />
            </Stack>

            {/* Row 3 */}
            <Stack direction="row" gap={2}>
              {/* <TextField
                fullWidth
                type="date"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
              /> */}

              {/* Gender */}
              {/* <FormControl fullWidth>
                <Select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  displayEmpty
                  input={<TextField />}
                  renderValue={(selected) =>
                    selected ? (
                      selected
                    ) : (
                      <span style={{ color: "#aaa" }}>Select Gender</span>
                    )
                  }
                >
                  <MenuItem disabled value="">
                    Select Gender
                  </MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </Select>
              </FormControl> */}
            </Stack>

            {/* Row 4 */}
            <Stack direction="row" gap={2}>
              {/* Plan */}
              {/* <FormControl fullWidth>
                <Select
                  value={plan}
                  onChange={(e) => setPlan(e.target.value)}
                  displayEmpty
                  input={<TextField />}
                  renderValue={(selected) =>
                    selected ? (
                      selected
                    ) : (
                      <span style={{ color: "#aaa" }}>Select Plan</span>
                    )
                  }
                >
                  <MenuItem disabled value="">
                    Select Plan
                  </MenuItem>
                  <MenuItem value="Pro">Pro</MenuItem>
                  <MenuItem value="Standard">Standard</MenuItem>
                </Select>
              </FormControl> */}

              {/* Card Type */}
              {/* <FormControl fullWidth>
                <Select
                  value={cardType}
                  onChange={(e) => setCardType(e.target.value)}
                  displayEmpty
                  input={<TextField />}
                  renderValue={(selected) =>
                    selected ? (
                      selected.name
                    ) : (
                      <span style={{ color: "#aaa" }}>Select Card Type</span>
                    )
                  }
                >
                  <MenuItem disabled value="">
                    Select Card Type
                  </MenuItem>

                  {cardTypes.map((card) => (
                    <MenuItem key={card.id} value={card}>
                      {card.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Stack>
          </Stack>
        </DialogContent>

        <DialogActions>
          <StyledButton
            text={"Cancel"}
            variant="outlined"
            onClick={handleClose}
          />

          {!loading ? (
            <StyledButton
              variant="contained"
              text={"Create"}
              onClick={handleCreate}
            />
          ) : (
            <Button variant="contained">
              <CircularProgress size={25} />
            </Button>
          )}
        </DialogActions>
      </StyledDialog>
    </div>
  );
};

export default CreateAppUser;
